<template>
  <!-- 患者検索 -->
  <div id="AppPatientSearch">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">
              患者情報
              <span v-if="selectMode">選択</span>
              <span v-else>検索</span>
            </label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientCode"
                name="patientCode"
                data-vv-as="患者コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientName"
                name="patientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field
              label="患者名(カナ)"
              labelPosition="on-border"
              :type="{'is-danger':errors.has('patientNameKana')}"
              :message="errors.first('patientNameKana')"
            >
              <b-input
                v-model="searchConditions.patientNameKana"
                name="patientNameKana"
                data-vv-as="患者名(カナ)"
                type="text"
                field="patientNameKana"
                v-validate="'kanaCheck'"
                @typing="kanaInitialization()"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目-->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="品目コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productCode"
                name="productCode"
                data-vv-as="品目コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="品目名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productName"
                name="productName"
                data-vv-as="品目名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="シリアル" labelPosition="on-border">
              <b-input
                v-model="searchConditions.serialNumber"
                name="serialNumber"
                data-vv-as="シリアル"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--4行目-->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="電話番号" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientPhone"
                name="patientPhone"
                data-vv-as="電話番号"
                type="text|max:20"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="郵便番号
              " labelPosition="on-border">
              <b-input
                v-model="searchConditions.zipCode"
                name="zipCode"
                data-vv-as="郵便番号"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="住所" labelPosition="on-border">
              <b-input
                v-model="searchConditions.address"
                name="address"
                data-vv-as="住所"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--5行目-->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="療法" labelPosition="on-border">
              <b-select expanded v-model="searchConditions.ryoho">
                <option value></option>
                <option value="NPPV">NPPV</option>
                <option value="TPPV">TPPV</option>
                <option value="HFT">HFT</option>
                <option value="NPPV/HFT">NPPV/HFT</option>
                <option value="TPPV/HFT">TPPV/HFT</option>
                <option value="HOT">HOT</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="緊急連絡レベル" labelPosition="on-border">
              <b-select expanded v-model="searchConditions.emergencyLevel">
                <option value></option>
                <option value="1">S : NPPV 24h（マスク）</option>
                <option value="2">A : TPPV 24h（気切）</option>
                <option value="3">B : TPPV 夜間のみ（気切）</option>
                <option value="4">C : NPPV 夜間のみ（マスク）</option>
                <option value="5">D：HOT24h（設定値３L以上）</option>
                <option value="6">E：HOT24h（設定値３L未満）</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
            <b-button
              v-if="!selectMode"
              class="button"
              type="is-primary"
              native-type="button"
              style="margin-left:20px;"
              @click="download(searchConditions)"
            >患者情報ダウンロード</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span
              style="color: red"
              v-if="isSearchConditionKana&&!this.kanaJudg(searchConditions.patientNameKana)"
            >検索条件に誤りがあります。</span>
            <span style="color: red" v-else-if="isSearchConditionNull">検索条件を指定してください。</span>
            <span style="color: red" v-if="isSearchConditionAll"
              >全件検索となる為、検索条件を絞り込んでください。</span
            >
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
      <patientSearchResult
        ref="searchResultVue"
        v-bind:select-mode="selectMode"
        v-bind:multi-select-mode="multiSelectMode"
        v-bind:isNationwide="isNationwide"
        v-model="searchResult"
        v-bind:selected="selected"
        v-bind:searchConditions="searchConditions"
      />
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import resultTemplate from "./AppPatientSearchResult";
var data = [];
export default {
  props: ["selectMode", "isNationwideSearch", "multiSelectMode"],
  name: "AppPatientSearch",
  methods: {
    kanaInitialization: function() {
      this.isSearchConditionKana = false;
    },
    search: function(searchConditions) {
      if (
        this.isLength(this.searchConditions.patientCode) ||
        this.isLength(this.searchConditions.patientName) ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.productCode) ||
        this.isLength(this.searchConditions.productName) ||
        this.isLength(this.searchConditions.patientPhone) ||
        this.isLength(this.searchConditions.serialNumber) ||
        this.isLength(this.searchConditions.zipCode) ||
        this.isLength(this.searchConditions.patientNameKana) ||
        this.isLength(this.searchConditions.emergencyLevel) ||
        this.isLength(this.searchConditions.ryoho) ||
        this.isLength(this.searchConditions.address) ||
        this.searchConditions.includeDeleted
      ) {
        if (
          this.searchConditions.patientNameKana &&
          this.isLength(this.searchConditions.patientNameKana) &&
          !this.kanaJudg(this.searchConditions.patientNameKana)
        ) {
          this.isSearchConditionKana = true;
        } else {
          console.log("検索条件あり");
          this.isSearchConditionNull = false;

          if (
            !this.isLength(this.searchConditions.patientCode) &&
            !this.isLength(this.searchConditions.patientName) &&
            !this.isLength(this.searchConditions.officeCode) &&
            !this.isLength(this.searchConditions.hospitalCode) &&
            !this.isLength(this.searchConditions.hospitalName) &&
            !this.isLength(this.searchConditions.productCode) &&
            !this.isLength(this.searchConditions.productName) &&
            !this.isLength(this.searchConditions.patientPhone) &&
            !this.isLength(this.searchConditions.serialNumber) &&
            !this.isLength(this.searchConditions.zipCode) &&
            !this.isLength(this.searchConditions.patientNameKana) &&
            !this.isLength(this.searchConditions.emergencyLevel) &&
            !this.isLength(this.searchConditions.ryoho) &&
            !this.isLength(this.searchConditions.address) 
          ) {
            if (
              this.isSearchAll(
                [this.searchConditions.includeDeleted ? 1 : 0, 1]
              )
            ) {
              this.isSearchConditionAll = true;
              return;
            }
          }
          this.isSearchConditionAll = false;

          // 検索実行
          var excuteApi = this.getPatientListPOST;
          var successCallBack = this.getPatientListSuccess;
          var errorCallBack = this.getPatientListError;
          // WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
        this.isSearchConditionAll = false;
      }
    },
    download: function(searchConditions) {
      if (
        this.isLength(this.searchConditions.patientCode) ||
        this.isLength(this.searchConditions.patientName) ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.productCode) ||
        this.isLength(this.searchConditions.productName) ||
        this.isLength(this.searchConditions.patientPhone) ||
        this.isLength(this.searchConditions.serialNumber) ||
        this.isLength(this.searchConditions.zipCode) ||
        this.isLength(this.searchConditions.patientNameKana) ||
        this.isLength(this.searchConditions.emergencyLevel) ||
        this.isLength(this.searchConditions.ryoho) ||
        this.isLength(this.searchConditions.address) ||
        this.searchConditions.includeDeleted
      ) {
        if (
          this.isLength(this.searchConditions.patientNameKana) &&
          !this.kanaJudg(this.searchConditions.patientNameKana)
        ) {
          this.isSearchConditionKana = true;
        } else {
          console.log("検索条件あり");
          this.isSearchConditionNull = false;

          if (
            !this.isLength(this.searchConditions.patientCode) &&
            !this.isLength(this.searchConditions.patientName) &&
            !this.isLength(this.searchConditions.officeCode) &&
            !this.isLength(this.searchConditions.hospitalCode) &&
            !this.isLength(this.searchConditions.hospitalName) &&
            !this.isLength(this.searchConditions.productCode) &&
            !this.isLength(this.searchConditions.productName) &&
            !this.isLength(this.searchConditions.patientPhone) &&
            !this.isLength(this.searchConditions.serialNumber) &&
            !this.isLength(this.searchConditions.zipCode) &&
            !this.isLength(this.searchConditions.patientNameKana) &&
            !this.isLength(this.searchConditions.emergencyLevel) &&
            !this.isLength(this.searchConditions.ryoho) &&
            !this.isLength(this.searchConditions.address) 
          ) {
            if (
              this.isSearchAll(
                [this.searchConditions.includeDeleted ? 1 : 0, 1]
              )
            ) {
              this.isSearchConditionAll = true;
              return;
            }
          }
          this.isSearchConditionAll = false;

          // ダウンロード実行
          var excuteApi = this.downloadPatientTextFilePOST;
          var errorCallBack = this.downloadPatientTextFilePOSTError;
          // WebAPI Call
          this.downloadApiCall(excuteApi, errorCallBack);
        }
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
        this.isSearchConditionAll = false;
      }
    },
    getSelectedItem: function() {
      return this.$refs.searchResultVue.getSelectedItem();
    },
    getPatientListPOST: function(client) {
      return client.apis.apiPatient.getPatientListPOST({
        body: {
          patientCode: this.searchConditions.patientCode,
          patientName: this.searchConditions.patientName,
          patientNameKana: this.searchConditions.patientNameKana,
          officeCode: this.searchConditions.officeCode,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          productCode: this.searchConditions.productCode,
          productName: this.searchConditions.productName,
          patientPhone: this.searchConditions.patientPhone,
          serialNumber: this.searchConditions.serialNumber,
          zipCode: this.searchConditions.zipCode,
          emergencyLevel: this.searchConditions.emergencyLevel,
          ryoho: this.searchConditions.ryoho,
          address: this.searchConditions.address,
          nationwideSearchFlag: this.isNationwide,
          includeDeleted: this.searchConditions.includeDeleted,
        }
      });
    },
    getPatientListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      var resultData = result.obj;
      for (var data of resultData) {
        data.duration = "";
        data.powerStatus = "";
      }
      this.searchResult = resultData;
    },
    getPatientListError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    downloadPatientTextFilePOST: function(client) {
      return client.apis.apiPatient.downloadPatientTextFilePOST({
        body: {
          patientCode: this.searchConditions.patientCode,
          patientName: this.searchConditions.patientName,
          patientNameKana: this.searchConditions.patientNameKana,
          officeCode: this.searchConditions.officeCode,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          productCode: this.searchConditions.productCode,
          productName: this.searchConditions.productName,
          patientPhone: this.searchConditions.patientPhone,
          serialNumber: this.searchConditions.serialNumber,
          zipCode: this.searchConditions.zipCode,
          emergencyLevel: this.searchConditions.emergencyLevel,
          ryoho: this.searchConditions.ryoho,
          address: this.searchConditions.address,
          includeDeleted: this.searchConditions.includeDeleted,
        }
      });
    },
    downloadPatientTextFilePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var isNationwide = true;
    if (this.$props.isNationwideSearch != undefined) {
      isNationwide = this.$props.isNationwideSearch;
    }

    var roleId = userInfo.roleId;
    var searchConditions = {
      patientCode: "",
      patientName: "",
      patientNameKana: "",
      officeCode: "",
      hospitalCode: "",
      hospitalName: "",
      productCode: "",
      productName: "",
      patientPhone: "",
      serialNumber: "",
      zipCode: "",
      emergencyLevel: "",
      ryoho: "",
      address: "",
      includeDeleted: false,
    };
    if (this.$route.params["patientSearchFlag"] && this.$route.params["searchConditions"] != undefined) {
      searchConditions = this.$route.params["searchConditions"];
    } else {
      if (roleId != 1 && roleId != 2) {
        searchConditions.officeCode = userInfo.officeCode;
        searchConditions.staffCode = userInfo.staffCode;
        searchConditions.staffName = userInfo.fullName;
      } else {
      }
    }
    return {
      searchConditions,
      searchResult: [],
      isSearchConditionNull: false,
      isSearchConditionAll: false,
      isSearchConditionKana: false,
      selected: "",
      userInfo,
      roleId,
      isNationwide
    };
  },
  components: {
    patientSearchResult: resultTemplate
  },
  watch: {
    selected: function(val) {
      this.$parent.selected = val;
    }
  },
  mounted: function() {
    // 初期検索抑止の為、コメントアウト
    // this.search();
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppPatientSearch.vue